<template>
	<div>
		<div class="hero shortselling-bg">
      <div class="inner">
        <h1>{{$t('shortSellingPage.text1')}}</h1>
        <h5 class="subtitle">{{$t('shortSellingPage.text2')}}</h5>
      </div>
    </div>

		<section class="section3">
			<div class="section-inner">
				<div class="article-col2-container">
					<div class="img-col">
						<img src="@/assets/images/shortselling-image1.png" alt="">
					</div>
					<div class="text-col">
						<h2 class="section-title">{{$t('shortSellingPage.text3')}}</h2>
						<p>{{$t('shortSellingPage.text4')}}</p>
					</div>
				</div>
			</div>
		</section>


		<section class="section3 light-gray">
			<div class="section-inner">
				<h2>{{$t('shortSellingPage.text5')}}</h2>
				<div class="spacer"></div>
				<div class="col4-grid text-left">
          <div class="col4-grid-item">
            <div><img src="@/assets/icons/shortselling-icon1.svg" alt="" /></div>
            <h5>{{$t('shortSellingPage.text6')}}</h5>
            <ul class="col-list">
							<li>{{$t('shortSellingPage.text7')}}</li>
							<li>{{$t('shortSellingPage.text8')}}</li>
							<li>{{$t('shortSellingPage.text9')}}</li>
						</ul>
          </div>
          <div class="col4-grid-item">
            <div><img src="@/assets/icons/shortselling-icon2.svg" alt="" /></div>
            <h5>{{$t('shortSellingPage.text10')}}</h5>
            <ul class="col-list">
							<li>{{$t('shortSellingPage.text11')}}</li>
							<li>{{$t('shortSellingPage.text12')}}</li>
							<li>{{$t('shortSellingPage.text13')}}</li>
						</ul>
          </div>
          <div class="col4-grid-item">
            <div><img src="@/assets/icons/shortselling-icon3.svg" alt="" /></div>
            <h5>{{$t('shortSellingPage.text14')}}</h5>
            <ul class="col-list">
							<li>{{$t('shortSellingPage.text15')}}</li>
							<li>{{$t('shortSellingPage.text16')}}</li>
							<li>{{$t('shortSellingPage.text17')}}</li>
						</ul>
          </div>
          <div class="col4-grid-item">
            <div><img src="@/assets/icons/shortselling-icon4.svg" alt="" /></div>
            <h5>{{$t('shortSellingPage.text18')}}</h5>
            <ul class="col-list">
							<li>{{$t('shortSellingPage.text19')}}</li>
							<li>{{$t('shortSellingPage.text20')}}</li>
							<li>{{$t('shortSellingPage.text21')}}</li>
						</ul>
          </div>
        </div>
			</div>
		</section>

		<section class="section3 white">
      <div class="section-inner">
        <h2 class="section-title">{{$t('shortSellingPage.text22')}}</h2>
        <p>{{$t('shortSellingPage.text23')}}</p>
        <router-link to="contact" class="contact-us"><BtnPrimary text="Contact us" /></router-link>
      </div>
    </section>
	</div>
</template>

<script>
import BtnPrimary from '@/components/BtnPrimary.vue';

export default {
	name: 'ShortSellingPage',
	components: { BtnPrimary },
	data() {
		return {
			
		};
	},

	mounted() {
		
	},

	methods: {
		
	},
};
</script>

<style lang="scss" scoped>

</style>